import { useEffect, useState } from "react";
import {
  FranchiseOpenChatDto,
  getFranchiseopenChat,
} from "../../../../../api/cafe";
import {
  OpenChatBackWrapper,
  OpenChatItemWrapper,
  OpenChatList,
  OpenChatListWrapper,
  OpenChatPubListWrapper,
} from "./style";
import { OpenChatDto } from "../..";
import { openNewWindow } from "../../../../../utils/common";

export interface OpenChatPubListProp {
  onClose: () => void;
  openChatLabel: OpenChatDto;
}
const OpenChatPubList = ({ onClose, openChatLabel }: OpenChatPubListProp) => {
  const [list, setList] = useState<FranchiseOpenChatDto[]>([]);
  const getData = async () => {
    const res = await getFranchiseopenChat(openChatLabel.label);
    const list = res.list.sort((a, b) => {
      const aUrl = a.openChatUrl !== "";
      const bUrl = b.openChatUrl !== "";

      if (aUrl === bUrl) return 0;
      return aUrl ? -1 : 1;
    });
    setList(list);
  };
  useEffect(() => {
    getData();
  }, []);
  return (
    <OpenChatPubListWrapper>
      <OpenChatBackWrapper onClick={() => onClose()}>
        <img src="/image-web/openChat/back.svg" alt="back" />
        돌아가기
      </OpenChatBackWrapper>
      <OpenChatListWrapper>
        <div className="header">
          <div className="title">{openChatLabel.label} 가맹점</div>
          <div
            className="button"
            onClick={() => openNewWindow(openChatLabel.url)}
          >
            {openChatLabel.label} 홀덤펍 홍보방
          </div>
        </div>
        <OpenChatList>
          {list.length > 0 &&
            list.map((item, index) => (
              <OpenChatItemWrapper key={index}>
                <div className="pub-info">
                  <div className="pub">{item.pubName}</div>
                  <div className="addr">{item.pubAddr}</div>
                </div>
                {item.openChatUrl && (
                  <div
                    className="button"
                    onClick={() =>
                      item.openChatUrl && openNewWindow(item.openChatUrl)
                    }
                  >
                    입장
                  </div>
                )}
              </OpenChatItemWrapper>
            ))}
        </OpenChatList>
      </OpenChatListWrapper>
    </OpenChatPubListWrapper>
  );
};

export default OpenChatPubList;
